import md5 from 'js-md5'
import { getLinkedInUserInfo } from '@/api/thirdParty'

var state = ''
var IN = {}

function login(client_id) {
   toLoginPage(client_id);
}

function toLoginPage(client_id) {
   state = md5(new Date().setTime() + '_in_pc');
   var url = 'https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=' + client_id + '&redirect_uri=' + window.location.protocol + '//' + window.location.host + '/login' + '&state=' + state + '&scope=r_liteprofile%20r_emailaddress'
   // var url = 'https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=' + client_id + '&redirect_uri=https://bl-test.klef.cn/login&state=' + state + '&scope=r_liteprofile%20r_emailaddress'
   window.location.href = url;
}

function watchIN(success, error) {
   if (window.location.href.indexOf('state') == -1) {
      if (error) {
         error();
      }
      return;
   }
   if (success) {
      success();  
   }
}

function getMeInfo(token, success, error) {
   getLinkedInUserInfo({
      redirectUri: window.location.protocol + '//' + window.location.host + '/login',
      linkedInCode: token,
      grantType: 'authorization_code'
    }).then(res => {
      if (res.data.code == 1000) {
         success(res);
         return; 
      }
      error('获取信息失败');
    })
}

export default IN = {
   login,
   watchIN,
   getMeInfo
}